<template>
  <!-- Simple color button when dropdown is closed -->
  <div 
    class="color-box" 
    v-if="!showDropdown" 
    @click="toggleDropdown"
  ></div>

  <!-- Dropdown when opened -->
  <b-dropdown 
    v-else
    id='ddown1'
    class='m-md-2 btn-sm-drop color-change drop-btn-color'
    @hidden="hideDropdown"
    @shown="$emit('shown')"
    ref="colorDropdown"
  >
    <b-dropdown-item
      v-for='(color, key) in client_color'
      :key='key'
      :value="key"
      @click='changeColor(color)'
    >
      <div class="color-option">
        <span class="color-swatch" :style="{ backgroundColor: color }"></span>
        <span class="color-name">{{key}}</span>
      </div>
    </b-dropdown-item>
  </b-dropdown>
</template>
<script>
import Api from '@/config/api';
import ApiService from '@/service/apiService';
import { mapMutations } from 'vuex';

export default {
  name: 'Dropdown',
  props: ['applicant'],
  data() {
    return {
      current_color: this.applicant.color,
      color_name: '',
      client_color: {
        白: '#fbfcff',
        赤: '#f4d6d2',
        黄: '#f6f9db',
        青: '#d4e3f7',
        グレー: '#e5e5e5',
      },
      showDropdown: false,
    };
  },
  methods: {
    ...mapMutations({
      mutateApplicantsAfterColorChange: 'mutateApplicantsAfterColorChange',
    }),
    toggleDropdown() {
      this.showDropdown = true;
      this.$nextTick(() => {
        if (this.$refs.colorDropdown) {
          this.$refs.colorDropdown.show();
            this.$nextTick(()=> {
              this.$refs.colorDropdown.$el.blur();
            })
        }
      });
    },

    hideDropdown() {
      this.showDropdown = false;
      this.$emit('hidden');
    },
    changeColor(color) {
      this.current_color = 'loading... ';
      // console.log(color);
      // this.$emit('color-change', color);
      // this.current_color = color;


      ApiService.put(Api.endpoints.CLIENT_COLOR_CHANGE(this.applicant.id), {
        color,
      })// eslint-disable-next-line
        .then(({ data }) => {
          this.current_color = color;
          this.$emit('color-change', color);
          this.mutateApplicantsAfterColorChange(data.data);
          this.hideDropdown();
        })
        .catch(({ response }) => this.parseErrorResponse(response));
    },
  },
};
</script>
<style>
  .color-change .dropdown-toggle {
    min-width: 10px !important ;
    width: 20px !important;
    height: 20px !important;
    border-radius: 5px;
    text-indent: -99999px;
    background-color: white;
  }
  .drop-btn-color .btn{
    height: 15px!important;
    width: 15px!important;
    padding: 5px 5px!important;

  }
  .color-box {
    margin: 0.5rem;
    height: 15px;
    width: 15px;
    color: #fff;
    border-radius: 5px 5px;
    border: 1px solid #6c757d;
  }
</style>

